"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JOB_OVERVIEW_COLUMNS = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _instants = require("web/shared/jobs/instants.js");
var _runStates = require("web/shared/jobs/runStates.js");
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _cells = require("web/shared/jobs/cells");
var _ScheduleCell = _interopRequireDefault(require("web/shared/jobs/ScheduleCell"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What the landing view shows about each declared job.
*
* Status leads, because the question the page is opened with is "is everything
* running?" and every other column is detail once that is answered.
*/ // When the job last ran, in one of the instant formats, or the formatter's
// placeholder when it never has.
function latestRunInstant(entry, format) {
  return (0, _cells.monoCell)(format(entry.latestRun == null ? null : entry.latestRun.at));
}
const JOB_OVERVIEW_COLUMNS = exports.JOB_OVERVIEW_COLUMNS = [{
  key: "status",
  header: "Status",
  render: entry => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.pill, (0, _runStates.runStateStyle)(entry.latestRun == null ? null : entry.latestRun.state))), {}, {
    children: (0, _runStates.latestRunLabel)(entry.latestRun)
  }))
}, {
  key: "job",
  header: "Job",
  render: entry => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.stackedCell)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.mono)), {}, {
      children: entry.jobKey
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.prose)), {}, {
      children: entry.description
    }))]
  }))
}, {
  key: "schedule",
  header: "Schedule",
  render: entry => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScheduleCell.default, {
    jobKey: entry.jobKey,
    schedule: entry.schedule
  })
}, {
  key: "lastRunDate",
  header: "Last run",
  render: entry => latestRunInstant(entry, _instants.formatDate)
}, {
  key: "lastRunTime",
  header: "At",
  render: entry => latestRunInstant(entry, _instants.formatTime)
}, {
  key: "run",
  header: "Run #",
  align: "right",
  render: entry => (0, _cells.monoCell)(entry.latestRun == null ? "—" : String(entry.latestRun.sequentialRunId))
}, {
  key: "mode",
  header: "Mode",
  render: entry => (0, _cells.mutedPill)(entry.executionMode.toLowerCase())
}, {
  key: "retries",
  header: "Retries",
  align: "right",
  render: entry => (0, _cells.monoCell)(String(entry.maxRetries))
}, {
  key: "error",
  header: "Last error",
  render: entry => {
    const latest = entry.latestRun;
    if (latest == null || latest.error == null) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.statusNeutral)), {}, {
        children: "\u2014"
      }));
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.errorText)), {}, {
      children: latest.error
    }));
  }
}];